import { IdType, IdVerificationStatus } from 'types/enums';
import { IdTypeLabel } from 'types/general.types';

export const getVerificationStatusMessage = (
  status: IdVerificationStatus,
  type: IdType
) => {
  switch (status) {
    case IdVerificationStatus.SUCCESS:
      return `You have successfully verified your ${IdTypeLabel[type]} number.`;
    case IdVerificationStatus.FAILURE:
      return `Not able to verify your ${IdTypeLabel[type]} number. Please retry or contact support.`;
    default:
      return undefined;
  }
};
